// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__P6Dks","bigColWidth":"Table_bigColWidth__1gj3b","biggerColWidth":"Table_biggerColWidth__snKfj","row":"Table_row__3jbGS","col":"Table_col__3fpYD"};